import React from "react";
import { Button, ButtonProps, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

interface HeaderButtonProps extends Omit<ButtonProps, "variant" | "size"> {
  children: React.ReactNode;
  onClick: () => void;
  size?: "compact" | "normal";
  icon?: React.ReactNode;
}

const HeaderButton: React.FC<HeaderButtonProps> = ({
  children,
  onClick,
  size = "normal",
  icon,
  sx,
  ...buttonProps
}) => {
  const theme = useTheme();

  const getSizeStyles = () => {
    switch (size) {
      case "compact":
        return {
          py: 0.5,
          px: 1.5,
        };
      case "normal":
      default:
        return {
          py: 0.75,
          px: 2,
        };
    }
  };

  return (
    <Button
      variant="contained"
      onClick={onClick}
      startIcon={icon}
      sx={{
        fontWeight: 500,
        borderRadius: 1,
        textTransform: "none",
        textShadow: "none",
        fontSize: (theme) => theme.typography.body2.fontSize,
        bgcolor: alpha(theme.palette.common.white, 0.9),
        color: theme.palette.primary.main,
        border: "none",
        transition: "all 0.3s ease",
        "&:hover": {
          bgcolor: theme.palette.common.white,
          transform: "translateY(-2px)",
          boxShadow: `0 4px 12px ${alpha(theme.palette.common.black, 0.2)}`,
        },
        ...getSizeStyles(),
        ...sx,
      }}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};

export default HeaderButton;
